import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Eye } from "lucide-react";
import { Reveal } from "./motion/Reveal";

/**
 * BlogCard — Reusable card for blog list page.
 * Expects post object from /api/blog endpoint.
 */
const BlogCard = ({ post, index = 0 }) => {
  const date = post.published_at
    ? new Date(post.published_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  return (
    <Reveal delay={index * 0.06}>
      <Link
        to={`/blog/${post.slug}`}
        className="group flex h-full flex-col border border-black/10 bg-white transition-colors hover:border-brand-ink"
        data-testid={`blog-card-${post.slug}`}
      >
        {/* Cover image */}
        <div className="relative overflow-hidden bg-brand-smoke">
          {post.cover_image ? (
            <img
              src={post.cover_image}
              alt={post.title}
              loading="lazy"
              className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          ) : (
            <div className="aspect-[16/9] w-full bg-gradient-to-br from-brand-smoke to-neutral-200 flex items-center justify-center">
              <span className="font-display text-4xl font-semibold text-black/10">PP</span>
            </div>
          )}
          {post.category && (
            <span className="absolute left-4 top-4 bg-brand-ink px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white">
              {post.category}
            </span>
          )}
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col p-6">
          <h3 className="font-display text-xl font-semibold leading-snug tracking-tight text-brand-ink group-hover:text-brand-red transition-colors line-clamp-2">
            {post.title}
          </h3>

          {post.summary && (
            <p className="mt-3 flex-1 text-sm leading-relaxed text-neutral-500 line-clamp-3">
              {post.summary}
            </p>
          )}

          <div className="mt-5 flex items-center justify-between border-t border-black/5 pt-4">
            <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.15em] text-neutral-400">
              {date && <span>{date}</span>}
              {post.read_time && (
                <span className="flex items-center gap-1">
                  <Clock size={10} /> {post.read_time} min read
                </span>
              )}
            </div>
            <ArrowUpRight
              size={16}
              className="text-neutral-400 transition-all group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-brand-red"
            />
          </div>
        </div>
      </Link>
    </Reveal>
  );
};

export default BlogCard;
